export const House = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12.9553 3.24072C12.7021 2.98763 12.3588 2.84546 12.0009 2.84546C11.6429 2.84546 11.2996 2.98763 11.0464 3.24072L2.07295 12.2128C2.01019 12.2756 1.96041 12.3501 1.92645 12.4321C1.89248 12.5141 1.875 12.602 1.875 12.6907C1.875 12.7795 1.89248 12.8674 1.92645 12.9494C1.96041 13.0314 2.01019 13.1059 2.07295 13.1686C2.1997 13.2954 2.37161 13.3666 2.55085 13.3666C2.63961 13.3666 2.72749 13.3491 2.80949 13.3151C2.89149 13.2812 2.96599 13.2314 3.02875 13.1686L12.0009 4.19517L20.973 13.1686C21.0997 13.2954 21.2716 13.3666 21.4509 13.3666C21.6301 13.3666 21.802 13.2954 21.9288 13.1686C22.0555 13.0419 22.1267 12.87 22.1267 12.6907C22.1267 12.5115 22.0555 12.3396 21.9288 12.2128L18.7509 9.03627V4.59072C18.7509 4.4117 18.6797 4.24001 18.5532 4.11342C18.4266 3.98684 18.2549 3.91572 18.0759 3.91572H16.7259C16.5468 3.91572 16.3751 3.98684 16.2486 4.11342C16.122 4.24001 16.0509 4.4117 16.0509 4.59072V6.33627L12.9553 3.24072Z"
      fill="#0AAAE6"
    />
    <path
      d="M12.0004 5.66113L20.1004 13.7611V19.4406C20.1004 19.9776 19.887 20.4927 19.5073 20.8725C19.1275 21.2522 18.6125 21.4656 18.0754 21.4656H5.92539C5.38833 21.4656 4.87326 21.2522 4.4935 20.8725C4.11374 20.4927 3.90039 19.9776 3.90039 19.4406V13.7611L12.0004 5.66113Z"
      fill="#0AAAE6"
    />
  </svg>
);
